$(document).ready(function() {
    
    if ($('.main-banner:not(.v2)').length) {
        $('.main-banner:not(.v2) .owl-carousel').each(function() {
            let $carousel = $(this);
            let isAnimating = false;

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 0,
                mouseDrag: false,
                touchDrag: false,
                animateOut: 'fadeLeft',
                onTranslate: function() { 
                    isAnimating = true;
                    owl.next('.container').find('.show-up.show').removeClass('show').addClass('hide');

                    setTimeout(() => {
                        let text = owl.find('.owl-item.active .hidden-text').html();
                        owl.next('.container').find('.title .show-up').html(`<span>${text}</span>`);

                        owl.next('.container').find('.show-up.hide').removeClass('hide');
                        setTimeout(() => {
                            owl.next('.container').find('.show-up').addClass('show');
                        }, 5);
                    }, 300);
                },
                onTranslated: function() { 
                    isAnimating = false;
                }
            });

            $carousel.parents('.main-banner').swipe({
                swipeLeft: function () {
                    if (!isAnimating) {
                        updateAnimation('fadeLeft');
                        owl.trigger('next.owl.carousel');
                    }
                },
                swipeRight: function () {
                    if (!isAnimating) {
                        updateAnimation('fadeRight');
                        owl.trigger('prev.owl.carousel');
                    }
                }
            });
            
            function updateAnimation(animation) {
                let owlInstance = owl.data('owl.carousel');
                owlInstance.settings.animateOut = animation;
            }

            setTimeout(() => {
                owl.next('.container').find('.aos-init').addClass('aos-animate');
            }, 300);
            setTimeout(() => {
                owl.next('.container').find('.show-up').addClass('show');
            }, 500);

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.main-banner.v2').length) {
        $('.main-banner.v2 .owl-carousel').each(function() {
            let $carousel = $(this);
            let isAnimating = false;

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 0,
                mouseDrag: false,
                touchDrag: false,
                animateOut: 'fadeLeft',
                onTranslate: function() { 
                    isAnimating = true;
                    owl.next('.container').find('.show-up.show').removeClass('show').addClass('hide');

                    setTimeout(() => {
                        let text = owl.find('.owl-item.active .hidden-text').html();
                        owl.next('.container').find('.title .show-up').html(`<span>${text}</span>`);

                        owl.next('.container').find('.show-up.hide').removeClass('hide');
                        setTimeout(() => {
                            owl.next('.container').find('.show-up').addClass('show');
                        }, 5);

                        owl.find('video').each(function() {
                            this.pause();
                            this.currentTime = 0;
                        });

                        owl.find('.owl-item.active video').each(function() {
                            this.play();
                        });                    
                    }, 300);
                },
                onTranslated: function() { 
                    isAnimating = false;
                    handleSlideAdvance();
                }
            });

            $carousel.parents('.main-banner').swipe({
                swipeLeft: function () {
                    if (!isAnimating) {
                        updateAnimation('fadeLeft');

                        if (owl.find('.owl-item').last().hasClass('active')) {
                            owl.trigger('to.owl.carousel', [0]);
                        } 
                        else {
                            owl.trigger('next.owl.carousel');
                        }
                    }
                },
                swipeRight: function () {
                    if (!isAnimating) {
                        updateAnimation('fadeRight');

                        let owlInstance = owl.data('owl.carousel');
                        let lastIndex = owlInstance.items().length - 1;
                        if (owl.find('.owl-item').first().hasClass('active')) {
                            owl.trigger('to.owl.carousel', [lastIndex]);
                        } 
                        else {
                            owl.trigger('prev.owl.carousel');
                        }
                    }
                }
            });
            
            function updateAnimation(animation) {
                let owlInstance = owl.data('owl.carousel');
                owlInstance.settings.animateOut = animation;
            }

            setTimeout(() => {
                owl.next('.container').find('.aos-init').addClass('aos-animate');

                owl.find('.owl-item.active video').each(function() {
                    this.play();
                });

                handleSlideAdvance();
            }, 300);
            setTimeout(() => {
                owl.next('.container').find('.show-up').addClass('show');
            }, 500);

            let hasAdvanced = false;

            function handleSlideAdvance() {
                let $activeItem = owl.find('.owl-item.active');
                let $video = $activeItem.find('video');

                hasAdvanced = false;
                clearTimeout(owl.data('advanceTimeout'));
                $('video').off('.autoadvance');

                function goToNextOnce() {
                    if (hasAdvanced) return;
                    hasAdvanced = true;

                    if (owl.find('.owl-item').last().hasClass('active')) {
                        owl.trigger('to.owl.carousel', [0]);
                    } 
                    else {
                        owl.trigger('next.owl.carousel');
                    }
                }

                if ($video.length) {
                    $video.on('ended.autoadvance', function () {
                        goToNextOnce();
                    });
                } 
                else {
                    const timeout = setTimeout(() => {
                        goToNextOnce();
                    }, 3000);
                    owl.data('advanceTimeout', timeout);
                }
            }


            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.banner-counter').length) {
        $('.banner-counter .count-it').each(function () {
            let $this = $(this);
            
            let $countElement = $this;
            let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
        
            function random(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            let digitCount = originalNumber.toString().length;
            let random1 = random(digitCount);
            let random2 = random(digitCount);
            let random3 = random(digitCount);
    
            $countElement.html(`
                <span>${random1}</span>
                <span>${random2}</span>
                <span>${random3}</span>
                <span>${originalNumber}</span>
            `);
        });
    }

    if ($('.tri-image').length) {
        $('.tri-image .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                autoHeight: true,
                autoplay: true,
                autoplayTimeout: 3000,
                smartSpeed: 800,
                margin: 20
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.blocks-text').length) {
        $('.blocks-text .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: false,
                smartSpeed: 800,
                stagePadding: 30,
                margin: 20
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.scrolled-details').length) {
        let isDown = false;
        let startX;
        let scrollLeft;

        $('.scrolled-details .details').on('mousedown', function(e) {
            isDown = true;
            $(this).addClass('grabbing'); 
            startX = e.pageX - $(this).offset().left;
            scrollLeft = $(this).scrollLeft();
        });

        $(document).on('mouseup', function() {
            isDown = false;
            $('.scrolled-details .details').removeClass('grabbing');
        });

        $('.scrolled-details .details').on('mouseleave', function() {
            isDown = false;
            $(this).removeClass('grabbing');
        });

        $('.scrolled-details .details').on('mousemove', function(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - $(this).offset().left;
            const walk = (x - startX) * 1;
            $(this).scrollLeft(scrollLeft - walk);
        });

        let isSyncing = false;

        $('.details, .for-scroll .details').on('scroll', function () {
            if (isSyncing) return;
            isSyncing = true;

            let scrollLeft = $(this).scrollLeft();

            $('.details, .for-scroll .details').not(this).scrollLeft(scrollLeft);

            isSyncing = false;
        });
    }

    if ($('.toggle-images').length) {
        $('.toggle-images .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                autoplay:true,
                autoplayTimeout: 3000,
                autoHeight: true,
                smartSpeed: 800,
                margin: 0,
                mouseDrag: false,
                touchDrag: false,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut'
            }).on('changed.owl.carousel', function(event) {
                setTimeout(() => {
                    let slide = $carousel.find('.owl-item.active .item').data('slide');

                    $carousel.parents('.toggle-images').find('.toggle').removeClass('active');
                    $carousel.parents('.toggle-images').find(`.toggle[data-slide="${slide}"]`).addClass('active');
                }, 10);
            });

            $(this).trigger('refresh.owl.carousel');

            $carousel.next('.container').find('.toggle').on('click', function() {
                $carousel.next('.container').find('.toggle').removeClass('active');
                $(this).addClass('active');

                owl.trigger('to.owl.carousel', $(this).data('slide'))
            });
        });
    }

    if ($('.images-slider').length) {
        $('.images-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 200,
                responsive: {
                    0: {
                        stagePadding: 0,
                        margin: 20
                    },
                    768: {
                        stagePadding: 80,
                        margin: 30
                    },
                    1250: {
                        stagePadding: 200,
                        margin: 30
                    }
                }
            });

            setTimeout(() => {
                let img_h = $carousel.find('.image-container').height() / 2;
                $floatNav.css('top', `${img_h}px`);
            }, 200);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $carousel.find('.image-container').on('mouseenter', function() {
                $(this).find('.hover').addClass('active');
            }).on('mouseleave', function() {
                $(this).find('.hover').removeClass('active');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    banner_counter();
    bg_image_text();
    tri_image();
    blocks_text();
    scrolled_details();
    stack_effect();
    auto_stack_effect();

});

$(window).scroll(function() {
    banner_counter();
    bg_image_text();
    tri_image();
    blocks_text();
    scrolled_details();
    stack_effect();
    auto_stack_effect();
});

$(window).resize(function() {
    stack_effect();
    auto_stack_effect();
});

function banner_counter() {
    if ($('.banner-counter').length) {
        $('.banner-counter').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 50) {
                let $items = el.find('.show-up');
                let index = 0;

                let $items2 = el.find('.aos-init');
                let index2 = 0;

                let interval = setInterval(function() {
                    if (index < $items.length) {
                        $items.eq(index).addClass('show');
                        index++;
                    } else {
                        clearInterval(interval);

                        let interval2 = setInterval(function() {
                            if (index2 < $items2.length) {
                                $items2.eq(index2).addClass('aos-animate');
                                index2++;
                            } else {
                                clearInterval(interval2);
                                el.find('.count-it span').addClass('active');
                            }
                        }, 50);

                    }
                }, 100);
            }
        });    
    }
}

function bg_image_text() {
    if ($('.bg-image-text').length) {
        $('.bg-image-text').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
                //el.find('.bg').css('background-size', '100%');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
                //el.find('.bg').css('background-size', '80%');
            }
        });    
    }
}

function tri_image() {
    if ($('.tri-image').length) {
        $('.tri-image').each(function() {
            let el = $(this);

            if (wSize >= 1250) {
                let scroll = sectionPercent(el) * 1.5;

                if (scroll >= 120) {
                    el.find('.image-wrapper.left').css('left', '-20%');
                    el.find('.image-wrapper.right').css('right', '-20%');
                    el.find('.main-img').css('clip-path', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)');
    
                    el.find('.aos-init').addClass('aos-animate');
                }
                else {
                    el.find('.image-wrapper.left').css('left', '11%');
                    el.find('.image-wrapper.right').css('right', '11%');
                    el.find('.main-img').css('clip-path', 'polygon(32% 15%, 68% 15%, 68% 85%, 32% 85%)');
    
                    el.find('.aos-init').removeClass('aos-animate');
                }
            }
            else {
                let scroll = sectionPercent(el) ;

                if (scroll >= 20) {
                    el.find('.aos-init').addClass('aos-animate');
                }
                else {
                    el.find('.aos-init').removeClass('aos-animate');
                }
            }
        });    
    }
}

function blocks_text() {
    if ($('.blocks-text').length) {
        $('.blocks-text').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

let scrolledAutoStarted_desktop = false;
let scrolledAutoStarted_mobile = false;

let autoScrollInterval_desktop;
let autoScrollInterval_mobile;

let isHovered_desktop = false;
let isHovered_mobile = false;

function scrolled_details() {
    if ($('.scrolled-details').length) {
        $('.scrolled-details').each(function () {
            let el = $(this);

            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }

            if (!scrolledAutoStarted_desktop && visiblePercent(el.find('.desktop .details')) > 20) {
                scrolledAutoStarted_desktop = true;
                scrolled_details_auto_desktop();
            }

            if (!scrolledAutoStarted_mobile && visiblePercent(el.find('.mobile .details')) > 20) {
                scrolledAutoStarted_mobile = true;
                scrolled_details_auto_mobile();
            }
        });
    }
}

function scrolled_details_auto_desktop() {
    let $details = $('.scrolled-details .desktop .details');

    function startAutoScroll() {
        clearInterval(autoScrollInterval_desktop);

        autoScrollInterval_desktop = setInterval(() => {
            if (!isHovered_desktop) {
                let maxScroll = $details[0].scrollWidth - $details.outerWidth();
                let currentScroll = $details.scrollLeft();

                if (currentScroll < maxScroll) {
                    $details.scrollLeft(currentScroll + 1);
                } else {
                    clearInterval(autoScrollInterval_desktop);
                }
            }
        }, 20);
    }

    $details.off('mouseenter mouseleave mouseup');

    $details.on('mouseenter', function () {
        isHovered_desktop = true;
    });

    $details.on('mouseleave', function () {
        isHovered_desktop = false;
        let maxScroll = $details[0].scrollWidth - $details.outerWidth();
        if ($details.scrollLeft() < maxScroll) {
            startAutoScroll();
        }
    });

    $details.on('mouseup', function () {
        let maxScroll = $details[0].scrollWidth - $details.outerWidth();
        if (!isHovered_desktop && $details.scrollLeft() < maxScroll) {
            startAutoScroll();
        }
    });

    startAutoScroll();
}

function scrolled_details_auto_mobile() {
    let $details = $('.scrolled-details .mobile .details');

    function startAutoScroll() {
        clearInterval(autoScrollInterval_mobile);

        autoScrollInterval_mobile = setInterval(() => {
            if (!isHovered_mobile) {
                let maxScroll = $details[0].scrollWidth - $details.outerWidth();
                let currentScroll = $details.scrollLeft();

                if (currentScroll < maxScroll) {
                    $details.scrollLeft(currentScroll + 1);
                } else {
                    clearInterval(autoScrollInterval_mobile);
                }
            }
        }, 20);
    }

    $details.off('mouseenter mouseleave mouseup');

    $details.on('mouseenter', function () {
        isHovered_mobile = true;
    });

    $details.on('mouseleave', function () {
        isHovered_mobile = false;
        let maxScroll = $details[0].scrollWidth - $details.outerWidth();
        if ($details.scrollLeft() < maxScroll) {
            startAutoScroll();
        }
    });

    $details.on('mouseup', function () {
        let maxScroll = $details[0].scrollWidth - $details.outerWidth();
        if (!isHovered_mobile && $details.scrollLeft() < maxScroll) {
            startAutoScroll();
        }
    });

    startAutoScroll();
}

function stack_effect() {
    if ($('.stack-effect:not(.stack-only):not(.auto)').length) {
        $('.stack-effect:not(.stack-only):not(.auto)').each(function() {
            let el = $(this);
            let size = $(this).data('items') / 2;
            let scrolled = (sectionPercent(el) * size) + 25;
            let btn_height = $(this).find('.btn').outerHeight();
            let offset = 40;
            let mt = 80;
            let items = $(this).data('items');

            if (wSize >= 1250) {
                if (el.find('.container').attr('style'))
                    el.find('.container').css('height', `calc(100vh + ${btn_height}px)`);
            }
            else {
                let viewportHeight = $(window).height();
                let lastStackHeight = el.find('.stack').last().outerHeight(true);
                let lastStackVh = (lastStackHeight / viewportHeight) * 100;
                el.find('.container').css('height', `${lastStackVh+30}vh`);
            }
            
            if (wSize >= 1920) {
                mt = 80;
                offset = 40;
            }
            else if (wSize >= 1440) {
                mt = 60;
                offset = 30;
            }
            else if (wSize >= 1250) {
                mt = 40;
                offset = 20;
            }
            else if (wSize >= 0) {
                mt = 30;
                offset = 15;
            }

            el.find('.stack:not(.first)').each(function(index) {
                $(this).css('margin-top', `${mt*(index+1)}px`);
            });

            let maxHeight = 0;

            el.find('.stack').each(function () {
                let stackHeight = $(this).height();
                if (stackHeight > maxHeight) {
                    maxHeight = stackHeight; 
                }
            });
            el.find('.stack').css('height', maxHeight + 'px');

            let totalHeight = maxHeight + (mt*items) + btn_height;
            el.find('.stacks').css('height', `${totalHeight}px`);
            
            if (wSize >= 1250) {
                if (scrolled >= 120 && scrolled < 145) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
                }
                else if (scrolled >= 145 && scrolled < 170) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                }
                else if (scrolled >= 170) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="4"]').css('transform', 'translateY(0)');
                }
                else {
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px))`);
                }
            }
            else {
                if (scrolled >= 120 && scrolled < 145) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
                }
                else if (scrolled >= 145 && scrolled < 170) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                }
                else if (scrolled >= 170) {
                    if (items == 4) {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.7)');
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.8)');
                        el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(.9)');
                        el.find('.stack[data-stack="4"]').css('transform', 'translateY(0) scale(1)');
                    }
                    else if (items == 3) {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                        el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
                    }
                    else if (items == 2) {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
                    }
                    else {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
                    }
                }
                else {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px)) scale(1)`);
                }
            }
        });    
    }
}

$('.header .slide-item[data-url]').on('click', function() {
    let url = $(this).data('url');
    window.location.href = url;
});

$('.images-slider .image-container').on('click', function() {
    if (wSize >= 1250) {
        let url = $(this).data('url');
        window.location.href = url;
    }
});

let autoStack = false;
function auto_stack_effect() {
    if ($('.auto.stack-effect').length) {
        $('.auto.stack-effect').each(function() {
            let el = $(this);
            let scrolled = visiblePercent(el)
            let btn_height = $(this).find('.btn').outerHeight();
            let offset = 40;
            let mt = 80;
            let items = $(this).data('items');
            
            if (wSize >= 1920) {
                mt = 80;
                offset = 40;
            }
            else if (wSize >= 1440) {
                mt = 60;
                offset = 30;
            }
            else if (wSize >= 1250) {
                mt = 40;
                offset = 20;
            }
            else if (wSize >= 0) {
                mt = 30;
                offset = 15;
            }

            el.find('.stack:not(.first)').each(function(index) {
                $(this).css('margin-top', `${mt*(index+1)}px`);
            });

            let maxHeight = 0;
            
            el.find('.stack').each(function () {
                let stackHeight = $(this).height();
                if (stackHeight > maxHeight) {
                    maxHeight = stackHeight; 
                }
            });
            el.find('.stack').css('height', maxHeight + 'px');

            let totalHeight = maxHeight + (mt*items) + btn_height;
            el.find('.stacks').css('height', `${totalHeight}px`);

            if (wSize >= 1250) {
                if (scrolled >= 80 && !autoStack) {
                    autoStack = true;

                    setTimeout(() => {
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                        el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                        el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
                    }, 1000);

                    setTimeout(() => {
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                        el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                        el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    }, 2000);

                    setTimeout(() => {
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                        el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                        el.find('.stack[data-stack="4"]').css('transform', 'translateY(0)');
                    }, 3000);
                }
                /* else {
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px))`);
                } */
            }
            else {
                if (scrolled >= 80 && !autoStack) {
                    autoStack = true;

                    setTimeout(() => {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
                        el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                        el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
                    }, 1000);

                    setTimeout(() => {
                        el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                        el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                        el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
                        el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    }, 2000);

                    setTimeout(() => {
                        if (items == 4) {
                            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.7)');
                            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.8)');
                            el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(.9)');
                            el.find('.stack[data-stack="4"]').css('transform', 'translateY(0) scale(1)');
                        }
                        else if (items == 3) {
                            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                            el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
                        }
                        else if (items == 2) {
                            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
                        }
                        else {
                            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
                        }
                    }, 3000);
                }
                /* else {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px)) scale(1)`);
                } */
            }
        });    
    }
}

$('.auto.stack-effect .stack').on('click', function() {
    let el = $(this).parents('.auto.stack-effect');
    let index = $(this).data('stack');
    let items = el.data('items');

    let offset = 40;
    
    if (wSize >= 1920) {
        offset = 40;
    }
    else if (wSize >= 1440) {
        offset = 30;
    }
    else if (wSize >= 1250) {
        offset = 20;
    }
    else if (wSize >= 0) {
        offset = 15;
    }

    if (wSize >= 1250) {
        if (index == 1) {
            el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px))`);
            el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px))`);
        }
        else if (index == 2) {
            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
            el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px))`);
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px))`);
        }
        else if (index == 3) {
            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
            el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px))`);
        }
        else if (index == 4) {
            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
            el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
            el.find('.stack[data-stack="4"]').css('transform', 'translateY(0)');
        }
    }
    else {
        if (index == 1) {
            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
            el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
            el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset*3}px)) scale(1)`);
        }
        else if (index == 2) {
            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
            el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset*2}px)) scale(1)`);
        }
        else if (index == 3) {
            el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
            el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
            el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
            el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
        }
        else if (index == 4) {
            if (items == 4) {
                el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.7)');
                el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.8)');
                el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(.9)');
                el.find('.stack[data-stack="4"]').css('transform', 'translateY(0) scale(1)');
            }
            else if (items == 3) {
                el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
            }
            else if (items == 2) {
                el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
            }
            else {
                el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
            }
        }
    }
});